import React, { useState } from 'react';
import { menuItems } from '../constants/data';
import { cn } from '../lib/cn';
import IndexRow from './IndexRow';

interface MenuOverlayProps {
  open: boolean;
  onClose: () => void;
}

export default function MenuOverlay({ open, onClose }: MenuOverlayProps) {
  const [selected, setSelected] = useState<string | null>(null);

  return (
    <>
      {/* Backdrop — clicking outside the rows closes the menu */}
      {open && (
        <div
          className="fixed inset-0 top-[72px] z-40"
          onClick={onClose}
        />
      )}

      <div
        className={cn('menu-overlay fixed left-0 right-0 top-[72px] z-50', open && 'open')}
      >
        {menuItems.map((item, i) => {
          const isSelected = selected === item.index;
          return (
            <IndexRow
              key={item.index}
              category={item.category}
              index={item.index}
              name={item.name}
              theme={item.theme}
              href={item.href}
              target={item.target}
              className={cn('menu-row border-b border-avaris', isSelected && 'selected')}
              style={{ transitionDelay: `${i * 0.1}s` }}
              onClick={() => {
                setSelected(isSelected ? null : item.index);
                onClose();
              }}
            />
          );
        })}
      </div>
    </>
  );
}
